import api from "../axiosIntercepture";

export const fetchGRN = async (page, pageSize, filters = {}) => {
  try {

    const sendObj = {
      filters: filters,
      limit: pageSize,
      page: page + 1
    };


    const response = await api.post("grn/fetch-multi-dynamic", sendObj);

    console.log("GRN fetch response:", response);
    
    // More robust response validation
    if (!response.data?.success) {
      const errorMsg = response.data?.message || "Failed to fetch GRN data";
      throw new Error(errorMsg);
    }
    
    // Ensure we always return a valid array and never null/undefined
    return Array.isArray(response.data?.data.data) ? response.data.data.data : [];
  } catch (err) {
    console.error("Error fetching GRN data:", err);
    throw new Error(err?.response?.data?.message || "Failed to fetch GRN data");
  }
}



export const fetchGrnByGrnNumber = async (number) => {
  try {
    const response = await api.post(`grn/fetchById/${number}`);
    console.log("Fetched GRN by ID response:", response);
    return response.data?.data;
  } catch (err) {
    throw err?.response?.data?.message;
  }
}

export const refreshGrnWms = async () => {
  try {
    const response = await api.post("grn/refresh-wms");
    if (response.data?.success === false) {
      throw new Error(response.data?.message || "Failed to sync GRN with WMS");
    }
    return response?.data;
  } catch (err) {
    const message =
      err?.response?.data?.message ||
      err?.message ||
      "Failed to sync GRN with WMS";
    throw new Error(message);
  }
};

export const createGRN = async (payload) => {
  try {
    const response = await api.post("grn/create", payload);
    
    if (response.data?.success && response.data?.data) {
      return response.data.data;
    }
    return [];
  } catch (err) {
    console.error("Error creating GRN:", err);
    throw err?.response?.data?.message || "Failed to create GRN";
  }
}